/**
 * 빠른 등록 버튼 — 화면 우하단에 고정.
 *
 * 현장 담당자가 실제로 하는 일은 일정 등록 · 파일 업로드 · 메모, 이 셋이 대부분이다.
 * 그런데 등록 버튼은 섹션 헤더에 있어서, 목록을 아래로 훑다가 뭔가 남기려면 위로
 * 다시 올라가야 했다. 휴대폰에서는 스크롤 거리가 특히 길다.
 *
 * 그래서 스크롤과 무관하게 늘 같은 자리에 둔다. 다이얼로그는 이 컴포넌트가 열지
 * 않고 부모가 소유한다 — 같은 화면의 다른 버튼(예: 헤더의 업로드)과 같은 다이얼로그
 * 하나를 공유해야 두 경로로 열었을 때 상태가 갈라지지 않는다.
 *
 * 데스크톱에서도 남겨 둔다. 헤더 버튼이 접힌 좁은 창에서도 등록 경로가 하나는
 * 항상 살아 있어야 한다.
 */
import React from 'react';
import { Fab, useMediaQuery, useTheme } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

export interface QuickRecordFabProps {
  onClick: () => void;
  /** 라벨. 화면에 따라 '등록' 외의 말이 필요하면 바꾼다. */
  label?: string;
}

const QuickRecordFab: React.FC<QuickRecordFabProps> = ({ onClick, label = '등록' }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Fab
      color="primary"
      onClick={onClick}
      aria-label={label}
      // 좁은 화면에서는 원형 아이콘만 — 라벨까지 붙이면 목록 위를 크게 덮는다.
      variant={isMobile ? 'circular' : 'extended'}
      data-testid="quick-record-fab"
      sx={{
        position: 'fixed',
        right: { xs: 16, sm: 24 },
        // 모바일 하단 제스처 바를 피해 살짝 띄운다.
        bottom: { xs: 24, sm: 28 },
        zIndex: (t) => t.zIndex.fab,
        fontWeight: 700,
      }}
    >
      <AddIcon sx={{ mr: isMobile ? 0 : 1 }} />
      {!isMobile && label}
    </Fab>
  );
};

export default QuickRecordFab;
